"use client";

import {
    Grid,
    Tab,
    TabList,
    TabGroup,
    TabPanel,
    TabPanels,
} from "@tremor/react";
import { useSelector } from 'react-redux';
import { Skeleton } from "@mui/material";
import { CumulativeSalesByProduct, CumulativeSalesByProductGroup } from "./helper";
import ListProduct from "./list";
import KpiBarChart from "../component/barChart";
import ListProgressBarAccordion from "../component/listProgressBarAccordion";
import { isLoading } from "../component/loading/store";
import useTrademarkFilter from "../../hooks/useTrademarkFilter";

export default function Product() {
    const kpiProduct = useSelector((state) => state.kpiProduct)
    const loading = useSelector((state) => isLoading(state, 'KPI_PRODUCT'))

    // faz o filtro das listas de vendas por marca selecionada pelo usuário
    const filteredKpiProduct = useTrademarkFilter(kpiProduct)

    const cumulativeSalesByProductGroupKPI = CumulativeSalesByProductGroup(filteredKpiProduct)
    const cumulativeSalesByProductKPI = CumulativeSalesByProduct(filteredKpiProduct)

    return (
        <TabGroup className="mt-1">
            <TabList>
                <Tab>Visão geral</Tab>
                <Tab>Listagem</Tab>
            </TabList>
            <TabPanels>
                <TabPanel>
                    {!loading ? (
                        <Grid className="gap-6 mt-6">
                            <KpiBarChart {...cumulativeSalesByProductGroupKPI} />
                            <ListProgressBarAccordion {...cumulativeSalesByProductKPI} />
                        </Grid>
                    ) : (
                        <Grid className="gap-6 mt-6">
                            <Skeleton variant="rounded" height={200} />
                            <Skeleton variant="rounded" height={500} />
                        </Grid>
                    )}
                </TabPanel>
                <TabPanel>
                    <ListProduct data={kpiProduct.currentMonthSalesProduct || []} />
                </TabPanel>
            </TabPanels>
        </TabGroup>
    )
}
